module.exports = __webpack_public_path__ + "img/6-small.c9b47a98.png";